import React from "react";

export const Pagina404 = () => {
  return (
    
    <div className="containerPage">
        <div className="box">
            <img src="https://cdn-icons-png.flaticon.com/512/5680/5680361.png" alt="Página não encontrada!" className="imageLabel"/>
            <div>
            <label className="title" style={{padding:"15px"}}> ERROR 404</label>
            </div>

            <div>
            <label className="text404">Página não encontrada!</label>
            </div>
        </div>
    
    </div>
  );
};